import * as api from "Api";

class CollaboratorApi {
  getCollaboratorValuation(
    organizationId,
    collaboratorErpId,
    collaboratorUid,
    date,
    period
  ) {
    return api
      .getCollaboratorValuation(
        organizationId,
        collaboratorErpId,
        collaboratorUid,
        date,
        period
      )
      .then(response => response.data.data);
  }

  getPerformanceFolderStatistics(uid, organizationId) {
    return api
      .getPerformanceFolderStatistics(uid, organizationId)
      .then(response => response.data.data);
  }

  getPerformanceChartStatistics(organizationId, adminisId, uid, period, date) {
    return api
      .fetchPerformanceChartStatisticsByUser(
        organizationId,
        adminisId,
        uid,
        period,
        date
      )
      .then(response => response.data.data);
  }

  getCollaboratorScore(organizationId, adminisId, uid, period, date) {
    return api
      .fetchUserScore(organizationId, adminisId, uid, period, date)
      .then(response => response.data.data);
  }

  getCollaborators(idOrganization) {
    return api
      .getCollaborators(null, idOrganization)
      .then(response => response.data.data);
  }

  getCollaborator(idOrganization, collaboratorId, collaboratorUid) {
    return api.getCollaborator({
      organization: idOrganization,
      id: collaboratorId,
      uid: collaboratorUid
    });
  }
}

export default new CollaboratorApi();



// WEBPACK FOOTER //
// ./src/services/CollaboratorServices.js